export default {
    name: 'NBP / TTF DA @hour 12',
    data: {
        "id": "65375f2c-a7c1-4710-9659-6324cd9f529d",
        "type": "Composite",
        "title": "NBP/TTF DA",
        "config": {
            "operator": "Subtract",
            "combine_on": "date",
            "left": {
                "id": "391bb219-b781-4e2a-a366-baab59374325",
                "type": "Single",
                "config": {
                    "type_id": "vwap",
                    "hub_id": 21,
                    "product_id": 1,
                    "hour": "12",
                    "start_date": "2025-06-26",
                    "end_date": "2025-08-25"
                }
            },
            "right": {
                "id": "fa981a3f-c3f2-43f2-9670-c1774f2d3ed1",
                "type": "Single",
                "config": {
                    "type_id": "vwap",
                    "hub_id": 14,
                    "product_id": 1,
                    "hour": "12",
                    "start_date": "2025-06-26",
                    "end_date": "2025-08-25"
                }
            }
        }
    }
}